import { defineComponent as _defineComponent } from 'vue'
import useDrag from "@/composables/use-drag";
import { computed, ref, watch } from "vue";
import clamp from "@/utils/clamp";
import formatTime from "@/utils/format-time";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoTrim',
  props: {
    video: { type: Boolean },
    startTime: null,
    endTime: null,
    videoDuration: null,
    playbackProgress: null,
    minDuration: null,
    maxDuration: null
  },
  emits: ["stop", "trim"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "stop"): void;
  (e: "trim", startTime: number, endTime: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  video?: boolean;
  startTime: number;
  endTime: number;
  videoDuration: number;
  playbackProgress: number;
  minDuration: number;
  maxDuration: number;
}

const TRIM_SNAP_INTERVAL = 0.1;





const snap = (value: number): number => {
  const snapped = Math.round(value / TRIM_SNAP_INTERVAL) * TRIM_SNAP_INTERVAL;
  const rounded = Math.round(snapped * 10) / 10;

  return rounded;
};

const start = ref(0);
const end = ref(0);
const trimElement = ref<HTMLElement>();

watch(
  () => props.startTime,
  (value) => {
    start.value = value;
  },
  { immediate: true }
);

watch(
  () => props.endTime,
  (value) => {
    end.value = value;
  },
  { immediate: true }
);

const duration = computed(() => {
  return end.value - start.value;
});

const dragStartTime = useDrag((x, _y, event) => {
  emits("stop");

  const width = trimElement.value?.clientWidth ?? 1;
  const timeDelta = (x / width) * props.videoDuration;

  const min = 0;
  const max = end.value - props.minDuration;
  const newStartTime = snap(props.startTime + timeDelta);

  start.value = clamp(newStartTime, min, max);

  if (event.type === "mouseup") {
    emits("trim", start.value, end.value);
  }
});

const dragEndTime = useDrag((x, _, event) => {
  emits("stop");

  const width = trimElement.value?.clientWidth ?? 1;
  const timeDelta = (x / width) * props.videoDuration;

  const min = start.value + props.minDuration;
  const max = Math.min(props.videoDuration, start.value + props.maxDuration);
  const newEndTime = snap(props.endTime + timeDelta);

  end.value = clamp(newEndTime, min, max);

  if (event.type === "mouseup") {
    emits("trim", start.value, end.value);
  }
});

const durationAsPercent = computed(() => {
  return (duration.value / props.videoDuration) * 100;
});

const startTimeAsPercent = computed(() => {
  return (start.value / props.videoDuration) * 100;
});

return { __sfc: true,TRIM_SNAP_INTERVAL, emits, props, snap, start, end, trimElement, duration, dragStartTime, dragEndTime, durationAsPercent, startTimeAsPercent, formatTime }
}

})